<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">{{ $t('license.text.manageFrequent') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack href="/license/" />
        </div>
      </div>
    </div>
    <McGrapqlTable
      :apiClient="query"
      :fields="fields"
      :customHandlers="customHandlers"
      :hasDelete="hasAccess('license_notification:delete')"
      :hasCheckbox="hasAccess('license_notification:delete')"
      searchable
      showPagination
      withCard
      trackBy="emailNotificationId"
      class="mc-table--detail"
    >
      <template #thead-top>
        <b-th><span class="checkbox"></span></b-th>
        <b-th rowspan="2">
          <div class="d-flex align-items-center">
            {{ $t('notification.setting.emailNotification.groupName') }}
          </div>
        </b-th>
        <b-th colspan="2" class="text-center">
          {{ $t('maintenance.field.reminderRecipients') }}
        </b-th>
        <b-th rowspan="2">
          <div class="d-flex align-items-center">
            {{ $t('license.object.documentName') }}
          </div>
        </b-th>
        <b-th rowspan="2">
          <div class="d-flex align-items-center">
            {{ $t('notification.setting.emailNotification.createdBy') }}
          </div>
        </b-th>
      </template>
      <template #cell(email)="data">
        <div class="text-wrap">
          {{ data.value }}
        </div>
      </template>
      <template #cell(docTypes)="data">
        <div class="text-wrap">
          <span class="mc-status mc-status--red" v-if="data.item.docTypes === ''">
            {{ $t('license.text.emptyDocs') }}
          </span>

          <span v-else>
            {{ data.item.docTypes }}
          </span>
        </div>
      </template>
    </McGrapqlTable>
  </Layout>
</template>
<script>
import Layout from '@/router/layouts/main'
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'

import McButtonBack from '@/components/McButtonBack'
import McGrapqlTable from '@/components/McGrapqlTable'
import {
  GET_EMAIL_NOTIFICATIONS,
  DELETE_EMAIL_NOTIFICATION,
} from '@/services/api/license/vehicleDocs'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Pengingat Lisensi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McGrapqlTable,
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('license.object.reminder')
    },
    customHandlers() {
      const handlers = {
        handleClickRow: (item) => {
          return this.$router.push({
            name: 'Update License Reminder',
            params: { id: item.emailNotificationId },
          })
        },
      }

      if (this.hasAccess('license_notification:create')) {
        handlers.handleAdd = () => {
          return this.$router.push({
            name: 'Create License Reminder',
          })
        }
      }

      return handlers
    },
    fields() {
      return [
        {
          key: 'nameGroupEmail',
          label: this.$t('notification.setting.emailNotification.groupName'),
          sortable: true,
          isRedirectable: true,
          thClass: 'd-none',
        },
        {
          key: 'aggregate.whatsapp',
          label: 'WhatsApp',
        },
        {
          key: 'aggregate.email',
          label: this.$t('notification.setting.emailNotification.email'),
          sortable: true,
        },
        {
          key: 'docTypes',
          label: this.$t('license.object.documentName'),
          sortable: true,
          thClass: 'd-none',
        },
        {
          key: 'createdBy',
          label: this.$t('notification.setting.emailNotification.createdBy'),
          sortable: true,
          thClass: 'd-none',
        },
      ]
    },
    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_EMAIL_NOTIFICATIONS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                type: 'license',
              },
            },
          })

          const result = res.data.emailNotifications.emailNotifications
          result.data.forEach((res, ind) => {
            result.data[ind].docTypes = res.docTypes.replaceAll(',', ', ')
          })
          return result
        },
        delete: async (id) => {
          const res = await this.$apollo.query({
            query: DELETE_EMAIL_NOTIFICATION,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                emailNotificationIds: Number(id),
              },
            },
          })

          return res.data.deleteEmailNotifications
        },
      }
    },
  },
}
</script>
